import { QRCodeSVG } from "qrcode.react";
import { APP_LIVE, qrTarget } from "@/config/site";
import { MaskLines, Reveal, Eyebrow } from "./Motion";
import { StoreBadges } from "./StoreBadges";
import { GlowOrb } from "./Glow";

const Corner = ({ className }) => <span className={`absolute h-5 w-5 border-pa-orange ${className}`} aria-hidden="true" />;

export const QRDownload = () => {
  const target = qrTarget();
  return (
    <section id="download" data-testid="qr-download-section" className="relative overflow-hidden border-t border-white/10 bg-pa-surface">
      <GlowOrb className="right-0 top-1/2 h-[520px] w-[520px] -translate-y-1/2" strength="md" />
      <div className="relative mx-auto grid max-w-[1400px] items-center gap-14 px-5 py-20 sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-28">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>{APP_LIVE ? "Available now" : "Launching soon on iOS & Android"}</Eyebrow></Reveal>
          <MaskLines lines={["Take Pitchally", "with you."]} label="Take Pitchally with you." className="mt-6 font-display text-[clamp(2.9rem,7vw,6.5rem)] uppercase leading-[0.88]" />
          <Reveal delay={0.15}>
            <p className="mt-6 text-base text-pa-muted md:text-lg">
              Scan to download the app.{" "}
              {!APP_LIVE && <span className="text-pa-ink">Until launch day, the code takes you straight to the waitlist.</span>}
            </p>
            <StoreBadges idPrefix="qr-store-badge" source="qr-section" className="mt-10" />
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5 lg:justify-self-end">
          <div data-testid="qr-download-container" className="relative w-fit p-6">
            <Corner className="left-0 top-0 border-l-2 border-t-2" />
            <Corner className="right-0 top-0 border-r-2 border-t-2" />
            <Corner className="bottom-0 left-0 border-b-2 border-l-2" />
            <Corner className="bottom-0 right-0 border-b-2 border-r-2" />
            <div className="bg-pa-ink p-5 shadow-[0_0_80px_-10px_rgba(242,101,49,0.6)]">
              <QRCodeSVG data-testid="qr-code-svg" value={target} size={208} bgColor="#F5F1EB" fgColor="#0F0F0F" level="M" title={APP_LIVE ? "Scan to download Pitchally" : "Scan to join the Pitchally waitlist"} />
            </div>
            <p className="mt-4 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-pa-dim">{APP_LIVE ? "Scan · Download" : "Scan · Join waitlist"}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
